<template>
  <section>
    <!-- Componentes externos -->
    <crear-permiso-cargo-vacacion />
    <EditarPermisoCargoVacacion />
    <SolicitarPermiso />
    <VerPermiso />
    <VerReporte />
    <AnularPermiso />
    <VerDocumento />
    <v-layout row wrap>
      <v-flex xs12 md6>
        <h3 class="primary--text">
          <v-icon color="primary">description</v-icon> Solicitud con cargo a
          vacación
        </h3>
      </v-flex>
      <!-- Seleccionar gestion-->
      <v-flex xs12 md6>
        <v-autocomplete
          class="text-field-reducido"
          :items="lista_gestiones"
          item-text="periodo"
          item-value="periodo"
          label="Seleccione la gestión"
          v-model="periodo_seleccionado"
          @change="actualizarTabla()"
          required
          outline
          success
          clearable
        ></v-autocomplete>
      </v-flex>
    </v-layout>
    <h4 style="color: #000" v-if="!esUsuario">
      <b>NOMBRE COMPLETO:</b> <v-spacer></v-spacer> {{ nombres }}
    </h4>
    <v-card>
      <!-- Dias no programados o dias de reserva -->
      <v-card-text class="pb-0">
        <v-card
          v-if="sw_programacion"
          color="indigo"
          class="px-3 white--text text-xs-center text-md-left"
        >
          <v-layout row wrap>
            <v-flex xs12 md4
              ><span class="caption">DÍAS RESERVA</span><br />
              <span class="display-1" v-if="!!datos_estado_vacacion">
                {{ datos_estado_vacacion.dias_reserva }}
              </span>
            </v-flex>
            <v-flex xs12 md4
              ><span class="caption">DÍAS RESERVA SOLICITADOS</span><br />
              <span class="display-1">{{ total_dias_creados_reserva }}</span>
            </v-flex>
            <v-flex xs12 md4
              ><span class="caption">NOTA A CONSIDERAR</span><br />
              <span class="titulo"
                >Los días de reserva se encontrarán vigentes desde el
                {{
                  $moment(datos_programacion.fecha_corte).format("DD/MM/YYYY")
                }}
                hasta el 31/12/{{ datos_programacion.gestion - 1 }}, posterior a
                esta fecha los días no utilizados se adicionarán al total de
                días no programados de vacación (según corresponde)
              </span>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card v-else color="blue" class="px-3 white--text ">
          <span class="caption">TOTAL DÍAS NO PROGRAMADOS</span><br />
          <span class="display-1">{{ total_vacacion_disponible }}</span>
        </v-card>
      </v-card-text>
      <v-card-text class="py-0">
        <v-tooltip bottom>
          <v-btn
            v-if="
              (sw_programacion &&
                !!datos_estado_vacacion &&
                datos_estado_vacacion.dias_reserva -
                  total_dias_creados_reserva >
                  0) ||
                !sw_programacion
            "
            color="primary"
            slot="activator"
            @click="crearPermisoCargoVacacion()"
            ><v-icon>event_note</v-icon> Nueva Solicitud
          </v-btn>
          <span>Nueva solicitud con cargo a vacación</span>
        </v-tooltip>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="l_papeletas"
          :widthModal="840"
          :rows-per-page-items="[10, 25, { text: 'Todos', value: -1 }]"
        >
          <template v-slot:items="items">
            <td class="text-xs-center">{{ items.item.numero }}</td>
            <td class="text-xs-center">{{ items.item.fecha_desde }}</td>
            <td class="text-xs-center">{{ items.item.fecha_retorno }}</td>
            <td class="text-xs-center">{{ items.item.nro_dias }}</td>
            <td class="text-xs-center">{{ items.item.estado_permiso }}</td>
            <td class="text-xs-center">
              {{
                items.item.jefe &&
                (items.item.permiso.id_estado == 6 ||
                  items.item.permiso.id_estado == 7)
                  ? items.item.jefe
                  : " "
              }}
            </td>
            <td class="text-xs-center">{{ items.item.fecha_emision }}</td>
            <td class="text-xs-center">
              {{
                items.item.rechazo
                  ? items.item.rechazo
                  : items.item.justificacion
                  ? items.item.justificacion
                  : ""
              }}
            </td>

            <td class="nowrap text-xs-center">
              <v-btn
                color="info"
                @click.prevent="verPermiso(items.item)"
                icon
                title="Ver permiso"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="items.item.permiso.id_estado == 22"
                color="warning"
                @click.prevent="editarPermisoCargoVacacion(items.item)"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                color="red"
                v-if="items.item.permiso.id_estado == 22"
                @click.prevent="anularPermiso(items.item.id_permiso)"
                icon
                dark
                title="Anular"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  items.item.permiso.id_estado == 75 ||
                    items.item.permiso.id_estado == 7 ||
                    items.item.permiso.id_estado == 6 ||
                    items.item.permiso.id_estado == 21 ||
                    items.item.permiso.id_estado == 77
                "
                color="#F58736"
                @click.prevent="verReporte(items.item)"
                icon
                title="Ver reporte"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
              <v-btn
                color="success"
                v-if="items.item.permiso.id_estado == 22"
                @click.prevent="solicitarPermiso(items.item)"
                icon
                title="Enviar"
              >
                <v-icon>send</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import EditarPermisoCargoVacacion from "./dialogs/EditarPermisoCargoVacacion.vue";
import CrearPermisoCargoVacacion from "./dialogs/CrearPermisoCargoVacacion";
import SolicitarPermiso from "./dialogs/SolicitarPermiso";
import VerPermiso from "./dialogs/VerPermiso";
import AnularPermiso from "./dialogs/AnularPermiso";
import VerReporte from "../permiso/dialogs/VerReporte.vue";
// Ver documento
import VerDocumento from "../permiso/dialogs/VerDocumento.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  data() {
    return {
      user: this.$storage.get("user"),
      esUsuario: this.$route.params.id == null,
      nombres: "",
      rol: [],
      rol2: [],
      rol3: [],
      lista_gestiones: [],
      bandera_fecha_corte: true,
      periodo_seleccionado: new Date().getFullYear(),
      total_vacacion_disponible: 0,
      // Variables tabla
      l_papeletas: [],
      headers: [
        { text: "Nro", align: "center", value: "numero", sortable: false },
        {
          text: "Fecha desde",
          align: "center",
          value: "fecha_desde",
          sortable: false
        },
        {
          text: "Fecha hasta",
          align: "center",
          value: "fecha_retorno",
          sortable: false
        },
        { text: "Días", align: "center", value: "nro_dias", sortable: false },
        {
          text: "Estado",
          align: "center",
          value: "estado_permiso",
          sortable: false
        },
        {
          text: "Solicitud enviada a",
          align: "center",
          value: "jefe",
          sortable: false
        },
        {
          text: "Fecha solicitud",
          align: "center",
          value: "fecha_emision",
          sortable: false
        },
        {
          text: "Justificación",
          align: "center",
          value: "rechazo",
          sortable: false
        },
        { text: this.$t("common.actions"), align: "center", sortable: false }
      ],
      // Variables control programacion
      datos_programacion: null,
      datos_estado_vacacion: null
    };
  },
  computed: {
    sw_programacion() {
      if (!!this.datos_programacion) {
        return (
          this.datos_programacion.gestion == new Date().getFullYear() + 1 &&
          this.$moment(this.datos_programacion.fecha_corte) <=
            this.$moment().startOf("day") &&
          this.$moment().startOf("day") <= this.$moment().endOf("year")
        );
      } else {
        return false;
      }
    },
    // Variable para calcular dias de reserva de la lista
    total_dias_creados_reserva() {
      return this.l_papeletas.reduce((accumulator, current) => {
        return (
          accumulator +
          (this.$moment(this.datos_programacion.fecha_corte) <=
            this.$moment(current.permiso._created_at) &&
          this.$moment(current.permiso._created_at) <=
            this.$moment().endOf("year") &&
          ![9, 83].includes(parseInt(current.permiso.id_estado))
            ? parseFloat(current.nro_dias)
            : 0)
        );
      }, 0);
    }
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    await this.obtenerListaGestiones();
    await this.obtenerFechaCorte();
    await this.cargarPapeletas();
    // Cargar datos de la ultima programacion
    await this.obtieneDatosUltimaProgramacion();
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.getNombre();
    await this.obtenerSaldoVacacionesPapeletas();
    this.$bus.$on("closeDialog", async () => {
      await this.cargarPapeletas();
      this.getNombre();
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogAnularPapeletaVacacion", async () => {
      this.getNombre();
      await this.obtenerSaldoVacacionesPapeletas();

      await this.cargarPapeletas();
    });
    this.$bus.$on("closeDialogPapeletaVacacion", async () => {
      await this.cargarPapeletas();
      this.getNombre();
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogCrearPapeletaVacacion", async () => {
      await this.cargarPapeletas();
      this.getNombre();
      await this.obtenerSaldoVacacionesPapeletas();
    });
  },

  // Métodos y funciones del componente
  methods: {
    async cargarPapeletas() {
      let res = await this.$service.graphql({
        query: `
					query{
							vPermisosPorFuncionarios(id_persona:${this.getPersonaId()},gestion:${
          this.periodo_seleccionado
        },id_tipo_permiso:24){
						rows{
              id_permiso
              id_persona
              nombres
              numero
              fecha_desde
              fecha_emision
              tipo_permiso
              fecha_retorno
              estado_permiso
              nro_dias
              gestion
              hora_desde
              hora_hasta
              id_lugar
              lugar_atencion
              fecha_nac_muerte
              hora_nac_muerte
              tipo_nac_muerte
              rango_horario
              rechazo
              horas_permiso
              id_tipo_permiso
              justificacion
              jefe
              compensa_tolerancia
              permiso{
                id
                motivo
                id_tipo_permiso
                ruta_archivo
                _created_at
                tipo_permiso{
                  id
                  id_parametro_elaborado
                }
              fecha_permiso
              numero
              fecha_registro
              id_estado
              lugar
              estado{
                descripcion
                    }
                  }
						    }
					    }
						}
					`
      });
      this.l_papeletas = res.vPermisosPorFuncionarios.rows;
    },
    // Metodo para obtener la ultima gestion de programacion
    async obtieneDatosUltimaProgramacion() {
      // Obtenemos datos programacion de vacaciones si existe de la gestion siguiente
      let l_programaciones = await this.$query.select("programacion", {}, [
        "porcentaje",
        "gestion",
        "fecha_corte",
        "fecha_inicio",
        "fecha_fin",
        "fecha_ampliacion"
      ]);
      // Ordenamos la lista descendentemente para obtener el mayor
      l_programaciones.sort((a, b) => b.gestion - a.gestion);
      this.datos_programacion = l_programaciones[0];
      // OBTENEMOS DATOS DEL ESTADO VACACION
      this.datos_estado_vacacion = await this.$query.select(
        "estado_vacacion",
        {
          id_persona: this.user.id_persona,
          periodo: this.datos_programacion.gestion
        },
        ["id", "dias_reserva"]
      );
      this.datos_estado_vacacion = this.datos_estado_vacacion[0];
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    anularPermiso(item) {
      this.$bus.$emit("openDialogAnularPermisoAnularPapeletaVacacion", item);
    },
    verReporte(item) {
      this.$bus.$emit("openDialogVerReportePermiso", item);
    },
    async obtenerFechaCorte() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select case when now()::date between vp.fecha_corte and coalesce (vp.fecha_aprobacion,now()::date) then false else true end valor from vacaciones.v_programacion vp where vp.gestion =(select max(vp.gestion) from vacaciones.v_programacion vp)"){
                  respuesta
                  }
                }
              `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          if (respuesta.runQuery.respuesta[0].valor == true) {
            this.bandera_fecha_corte = true;
            return;
          } else {
            this.bandera_fecha_corte = false;
            return;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    //metodo para obtener las gestiones:
    async obtenerListaGestiones() {
      try {
        let id_persona = this.$storage.get("user").id_persona;
        this.lista_gestiones = [];
        let resp = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select distinct extract (year from pd.fecha_desde)as periodo from control.permiso p join control.permiso_detalle pd on pd.id_permiso = p.id where p.id_persona = ${parseInt(
                    id_persona
                  )} union select extract (year from now())as periodo"){
                  respuesta
                  }
                }	
          `
        });

        if (resp.runQuery.respuesta.length > 0) {
          this.lista_gestiones = resp.runQuery.respuesta;
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para actualizar el crud table con una gestion
    async actualizarTabla() {
      if (!this.periodo_seleccionado) {
        return;
      }
      await this.cargarPapeletas();
    },
    async obtenerSaldoVacacionesPapeletas() {
      let saldo_total_para_papeleta = 0;
      let gestion_vigente = new Date().getFullYear();
      let id_persona;
      let resp2;
      try {
        if (
          this.$route.params.id == null ||
          this.$route.params.id == undefined
        ) {
          id_persona = this.user.id_persona;
        } else {
          id_persona = this.$route.params.id;
        }

        let respuesta2 = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select vacaciones.fn_obtiene_dias_para_cuenta_vacacion(${id_persona},${gestion_vigente})"){
              respuesta
              }
            }
          `
        });

        console.log("select vacaciones.fn_obtiene_dias_para_cuenta_vacacion()", id_persona, gestion_vigente);
        
        if (
          respuesta2.runQuery.respuesta[0]
            .fn_obtiene_dias_para_cuenta_vacacion != null &&
          respuesta2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion
        ) {
          resp2 =
            respuesta2.runQuery.respuesta[0]
              .fn_obtiene_dias_para_cuenta_vacacion;
          let respu = resp2.split("|");
          if (parseFloat(respu[1]) > 0) {
            saldo_total_para_papeleta = parseFloat(respu[1]);
          } else {
            saldo_total_para_papeleta = 0;
          }
        }
        this.total_vacacion_disponible = saldo_total_para_papeleta;
      } catch (error) {
        console.log(error);
      }
    },
    async crearPermisoCargoVacacion() {
      let fecha = new Date();
      let gestion_vigente = fecha.getFullYear();
      let id_persona;
      let dato = {};
      dato.rol = 42;
      let user = this.$storage.get("user");
      try {
        if (
          this.$route.params.id == null ||
          this.$route.params.id == undefined
        ) {
          id_persona = user.id_persona;
        } else {
          id_persona = this.$route.params.id;
        }
        // asigna total de Vacaciones restantes ,incluye creados y aprobados
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select control.fn_calcula_dias_permiso_por_vacacion_aprobados(${gestion_vigente},${id_persona})"){
                respuesta
              }
            }
          `
        });
        let resp =
          respuesta.runQuery.respuesta[0]
            .fn_calcula_dias_permiso_por_vacacion_aprobados;

            console.log("select control.fn_calcula_dias_permiso_por_vacacion_aprobados()", gestion_vigente,id_persona);

        //Verifica que tenga saldo de vacacaiones
        if (
          this.total_vacacion_disponible > 0 ||
          (this.sw_programacion &&
            this.datos_estado_vacacion.dias_reserva -
              this.total_dias_creados_reserva >
              0)
        ) {
          dato.saldo_no_programadas = this.total_vacacion_disponible;
          dato.total_vacaciones = parseFloat(resp);
          // Mandamos datos de reserva
          dato.sw_programacion = this.sw_programacion;
          dato.dias_reserva = this.datos_estado_vacacion.dias_reserva;
          dato.total_dias_creados_reserva = this.total_dias_creados_reserva;
          this.$bus.$emit("openDialogCrearPermisoCargoVacacion", dato);
        } else {
          this.$message.info(
            "Usted no dispone de días para realizar una papeleta de solicitud a cuenta de vacación en esta gestión"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async editarPermisoCargoVacacion(item) {
      let fecha = new Date();
      let gestion_vigente = fecha.getFullYear();
      item.rol = 42;
      let id_persona;
      let user = this.$storage.get("user");
      try {
        if (
          this.$route.params.id == null ||
          this.$route.params.id == undefined
        ) {
          id_persona = user.id_persona;
        } else {
          id_persona = this.$route.params.id;
        }
        // Verificamos que tenga vacaciones
        let respuesta = await this.$service.graphql({
          query: `
          query{
                  runQuery(consulta:"select vacaciones.fn_obtiene_saldo_vacacion_por_persona(${id_persona})"){
                  respuesta
                  }
                }

              `
        });
        let resp =
          respuesta.runQuery.respuesta[0].fn_obtiene_saldo_vacacion_por_persona;
        resp = resp.split("|");

        //obtener el saldo total de vacaciones no programadas
        let resp2;
        let respuesta2 = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select vacaciones.fn_obtiene_dias_para_cuenta_vacacion(${id_persona},${parseInt(
            gestion_vigente
          )})"){
                  respuesta
                  }
                }
              `
        });

        if (
          respuesta2.runQuery.respuesta[0]
            .fn_obtiene_dias_para_cuenta_vacacion == null ||
          !respuesta2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion
        ) {
          this.$message.info(
            `Usted no dispone de dias para programar en la gestión ${gestion_vigente} `
          );
        } else {
          if (
            parseFloat(
              respuesta2.runQuery.respuesta[0]
                .fn_obtiene_dias_para_cuenta_vacacion
            ) < 0.5
          ) {
          } else {
            resp2 =
              respuesta2.runQuery.respuesta[0]
                .fn_obtiene_dias_para_cuenta_vacacion;
            let respu = resp2.split("|");
            item.saldo_no_programadas = parseFloat(respu[1]);
            item.total_vacaciones = parseFloat(resp[1]);
            // Mandamos datos de reserva
            item.sw_programacion = this.sw_programacion;
            item.dias_reserva = this.datos_estado_vacacion.dias_reserva;
            item.total_dias_creados_reserva = this.total_dias_creados_reserva;
            this.$bus.$emit("openDialogEditarPermisoCargoVacacion", item);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    verPermiso(item) {
      this.$bus.$emit("openDialogVerPermiso", item);
    },
    solicitarPermiso(item) {
      this.$bus.$emit("openDialogSolicitarPermiso", item);
    },
    async getNombre() {
      try {
        let res = await this.$service.graphql({
          query: `query{
            personas(id: ${this.getPersonaId()}){
              rows{
                id
                ap_paterno
              ap_materno
                nombres
                ap_casada
              }
            }
          }
					`
        });

        let persona = res.personas.rows[0];
        this.nombres =
          persona.ap_paterno + " " + persona.ap_materno + " " + persona.nombres;

        let user = this.$storage.get("user");
        this.rol = user.roles[0].id;
        for (let i = 0; i < user.roles.length; i++) {
          const element = user.roles[i];
          if (element.id == 42 || element.id == 32) {
            this.rol2 = 42;
          } else {
            this.rol2 = 0;
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  // Definición de componentes importados
  components: {
    CrearPermisoCargoVacacion,
    EditarPermisoCargoVacacion,
    SolicitarPermiso,
    VerPermiso,
    AnularPermiso,
    VerReporte,
    VerDocumento
  }
};
</script>

<style lang="scss" scoped>
.titulo {
  color: rgb(243, 249, 253);
  font-weight: 700;
  font-size: 1.1rem;
  padding: 0rem 0.25rem;
}
</style>
s



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/Index.vue